import { Component, OnInit, Output,Input,EventEmitter } from '@angular/core';
import { ReportdashboardService } from '../../../services/reportdashboard.service';
import { Observable } from 'rxjs';
import { FormsModule, NgForm } from '@angular/forms';
import { ReportMetadata, VoluntaryReportMetadata ,Approver, ReportSchedule} from '../../../models/report.model';
import { environment } from '../../../../environments/environment';
import { AuthUserService } from '../../../services/appInitialization/authUser.service';
import { LookupService } from '../../../services/lookups/lookup.service';
import { NotifierService } from 'angular-notifier';
import { User } from '../../../models/user.model';



@Component({
  selector: 'app-rptmetadata',
  templateUrl: './rptmetadata.component.html',
  styleUrls: ['./rptmetadata.component.css']
})
export class RptmetadataComponent implements OnInit
{
  selectedApprover: User;
  selectedApproverName: string = '';
  currentUser: User;
  countryName: string = '';
  postName: string = '';
  categoryName: string = '';
  reportNumber: string = '';
  reportName: string = '';
  dueDate: Date;
  region: string = '';
  reportType: string = '';
  reportState: string = '';
  reportHighlights: string = '';
  preparedBy: string = '';

  @Output() showHideMetadata= new EventEmitter<boolean>();
  @Input() reportId:any;
  constructor(private reportService: ReportdashboardService,
              private lookupService:LookupService,
              private authUserService:AuthUserService,
              private authUser: AuthUserService,
              private notifier: NotifierService
              ) {

  }

  ngOnInit() {
       this.currentUser = this.authUser._user;

  }

   CancelReportMetadataDialog()
  {
    this.showHideMetadata.emit(false);
  }

  showMetadataDialog(report: any)
  {

    if(report.reportType.startsWith("Voluntary"))
    {
      this.reportService.getReportScheduleById(report.id).subscribe((metadata:VoluntaryReportMetadata)=>{
        this.reportNumber = metadata.reportNumber;
        this.reportName = metadata.reportName;
        this.dueDate = metadata.reportDate;
        this.region = metadata.region;
        this.reportType = metadata.reportType;
        this.reportState = metadata.reportState;
        this.reportHighlights = metadata.reportHighlights;
        this.preparedBy = metadata.preparedBy;
        this.selectedApproverName = metadata.approvedBy.fullName;
        this.categoryName = "";
        for (let i=0; i <metadata.reportCategory.length; i++)
        {
          this.categoryName += metadata.reportCategory[i].categoryName + ", ";
        }
        this.categoryName = this.categoryName.slice(0,-2);
        this.countryName = metadata.country.locationName;
        this.postName = metadata.post.locationName;
      });
    }
    else
    {
      this.reportService.getReportScheduleById(report.id).subscribe((metadata:ReportMetadata)=>{
        this.reportNumber = metadata.reportNumber;
        this.reportName = metadata.reportName;
        this.dueDate = metadata.dueDate;
        this.region = metadata.region;
        this.reportType = metadata.reportType;
        this.reportState = metadata.reportState;
        this.reportHighlights = metadata.highlights;
        this.preparedBy = metadata.preparedBy;
        this.categoryName = metadata.category;
        this.countryName = metadata.country;
        this.postName = metadata.fasPost;

        this.lookupService.getAllActiveUsers$().subscribe((data)=>{
          this.selectedApprover = data.map(u=>u).filter(u=> u.id=== metadata.approverId)[0];

        if (this.selectedApprover != null)
          this.selectedApproverName = this.selectedApprover.fullName;

      });

    });
    }
    this.showHideMetadata.emit(true);
  }
}
